import React from "react"
import { auditShape } from "utils/propTypeShapes"

const FallbackAuditItemDetails = ({ audit }) => {
  const {
    action, auditableType, auditableDeleted, associatedDeleted,
  } = audit

  return (
    <div>
      Performed an action: {action} {auditableType}. {(auditableDeleted || associatedDeleted) && "(record deleted)"}
    </div>
  )
}

FallbackAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default FallbackAuditItemDetails
